// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"pI-z","smallCardRow":"qI-z","largeCardRow":"rI-z","productSearchRow":"sI-z","curatedRow":"tI-z"};